import React from 'react'
import { useNavigate } from 'react-router-dom'
import { logger } from '../../logging'

import { View, Button } from '@aws-amplify/ui-react'

import { MyTmpVpnClient } from '@mytmpvpn/mytmpvpn-client'
import * as models from '@mytmpvpn/mytmpvpn-common/models/vpn'

import { reactUpdateVpnWithMetrics } from '../Common'
import { useErrorContext } from '../../ErrorContext'
import { VpnWithMetrics } from '../../pages/Home'
import { isClientAuthenticated } from '../../utils/authUtils'

async function deleteVpn(client: MyTmpVpnClient, setDeleteInProgress: any,
  vpnWithMetrics: VpnWithMetrics, setVpnsWithMetrics: any, setError: any) {

  if (!isClientAuthenticated(client)) {
    setError(new Error('Client not authenticated'))
    return
  }

  setDeleteInProgress(true)

  try {
    const deleteResponse = await client.deleteVpn(vpnWithMetrics.vpnId)
    const vpnWM: VpnWithMetrics = {
      ...deleteResponse.vpn,
      metrics: deleteResponse.metrics
    }

    setVpnsWithMetrics((prevVpnsWithMetrics: VpnWithMetrics[]) => {
      return reactUpdateVpnWithMetrics(prevVpnsWithMetrics, vpnWM)
    })

    logger.log(`Waiting for vpn to be in Deleted state ${JSON.stringify(deleteResponse.vpn)}`)
    const vpn = await client.waitUntilVpnStateIs(deleteResponse.vpn.vpnId, models.VpnState.Deleted, 300, (polledVpn: models.Vpn, pollCount: number) => {
      setVpnsWithMetrics((prevVpnsWithMetrics: VpnWithMetrics[]) => {
        return reactUpdateVpnWithMetrics(prevVpnsWithMetrics, {
          ...polledVpn,
          metrics: vpnWithMetrics.metrics,
          pollCount
        })
      })
    })

    logger.log(`Vpn is now in Deleted state ${JSON.stringify(vpn)}`)
    setVpnsWithMetrics((prevVpnsWithMetrics: VpnWithMetrics[]) => {
      return reactUpdateVpnWithMetrics(prevVpnsWithMetrics, {
        ...vpn, metrics: vpnWithMetrics.metrics
      })
    })
  } catch (e) {
    setError(e)
  } finally {
    setDeleteInProgress(false)
  }
}

export function Actions({ client, vpnWithMetrics, vpnsWithMetrics, setVpnsWithMetrics }: {
  client: MyTmpVpnClient, vpnWithMetrics: VpnWithMetrics,
  vpnsWithMetrics: VpnWithMetrics[], setVpnsWithMetrics: any
}) {

  const [deleteInProgress, setDeleteInProgress] = React.useState<boolean>(false)
  const { setError } = useErrorContext()
  const navigate = useNavigate()

  return (
    <View>
      <Button
        size="small"
        onClick={() => navigate(`/connect/${vpnWithMetrics.vpnId}`)}>
        Connect
      </Button>
      <Button
        size="small"
        isLoading={deleteInProgress}
        onClick={() => deleteVpn(client, setDeleteInProgress, vpnWithMetrics, setVpnsWithMetrics, setError)}>
        Delete
      </Button>
    </View>
  )
}
